import createFeatureDecisions from './services/createFeatureDecisions';

// eslint-disable-next-line import/prefer-default-export
export const featureDecisions = createFeatureDecisions();
